import React from 'react';
import './Galeria.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import GaleriaData from '../../Components/Admin/GaleriaData/GaleriaData';

export default function Galeria() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <GaleriaData />
                </div>
            </section>
        </div>
    );
}
